var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.invitationResent
        ? _c("p", { staticClass: "whitespace-no-wrap" }, [
            _vm._v(" Invitation resent "),
          ])
        : _vm._t("default", null, {
            setInvitationSentStatus: _vm.setInvitationSentStatus,
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }